import { createActions, createReducer } from 'reduxsauce'

import EmpreiteirasObrasService from '../../servicos/EmpreiteirasObrasService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaEmpreiteirasObrasInicio: [],
    buscaEmpreiteirasObrasSucesso: ['empreiteirasObras'],
    buscaEmpreiteirasObrasErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaEmpreiteirasObras = filtro => {
    return dispatch => {
        dispatch(Creators.buscaEmpreiteirasObrasInicio())
        let serv = new EmpreiteirasObrasService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaEmpreiteirasObrasSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaEmpreiteirasObrasErro(error)))
    }
}

const buscaEmpreiteirasObrasInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaEmpreiteirasObrasErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaEmpreiteirasObrasSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.empreiteirasObras, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_EMPREITEIRAS_OBRAS_INICIO]: buscaEmpreiteirasObrasInicio,
    [Types.BUSCA_EMPREITEIRAS_OBRAS_ERRO]: buscaEmpreiteirasObrasErro,
    [Types.BUSCA_EMPREITEIRAS_OBRAS_SUCESSO]: buscaEmpreiteirasObrasSucesso,
})
